import {
  booking,
  crm,
  dashboard,
  rkeeper,
  settings,
} from "@config/routes/items";
import { Missing } from "@pages";
import { RouteConfig } from "@types";

export const getRoutesConfig = (): RouteConfig[] => {
  return [
    dashboard(),
    rkeeper(),
    booking(),
    crm(),
    settings(),
    { path: "denied", element: <Missing /> },
  ];
};

export default getRoutesConfig;
